// extracted by mini-css-extract-plugin
export var orderSummary = "_p2-0";
export var showMoreLessButton = "_p2-1";